import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  CardHeader,
  Grid,
} from "@mui/material";
import GenericButton from "../../components/Custom/GenericButton";

const UserCampaignCard = ({
  campaign,
  isExpanded,
  onCardClick,
  onViewDocument,
  onSignUp,
  signupLoading,
}) => {
  return (
    <Grid item xs={12} mt={1}>
      <Card
        onClick={() => onCardClick(campaign.id)}
        sx={{
          boxShadow: "none",
          border: "1px solid #A5A5A5",
          cursor: "pointer",
          backgroundColor: isExpanded ? "#F5F5F5" : "#FFF",
        }}
      >
        <CardHeader
          title={
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              {campaign.title}
            </Typography>
          }
        />
        <CardContent>
          <Typography
            variant="body2"
            sx={{
              display: isExpanded ? "block" : "-webkit-box",
              WebkitLineClamp: isExpanded ? "none" : 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
            }}
          >
            {campaign.summary}
          </Typography>
        </CardContent>
        <CardActions>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <GenericButton
                backgroundColor="#4CAF50"
                padding="5px 0"
                disabled={!campaign.document}
                fontColor="#fff"
                fontSize="14px"
                onClick={(event) => {
                  event.stopPropagation();
                  onViewDocument(campaign.document);
                }}
              >
                {campaign.document ? "View Document" : "No Document"}
              </GenericButton>
            </Grid>

            {onSignUp && (
              <Grid item xs={6}>
                <GenericButton
                  backgroundColor="#4CAF50"
                  padding="5px 0"
                  disabled={signupLoading}
                  fontColor="#fff"
                  fontSize="14px"
                  onClick={(event) => {
                    event.stopPropagation();
                    onSignUp(campaign);
                  }}
                >
                  {signupLoading ? "Signing Up..." : "Sign Up"}
                </GenericButton>
              </Grid>
            )}
          </Grid>
        </CardActions>
      </Card>
    </Grid>
  );
};

export default UserCampaignCard;
